module.exports = __webpack_public_path__ + "static/media/purepapercolor-skin-dark-olive-017-1200x2490.935534b8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/purepapercolor-skin-dark-olive-017-1200x2490.jpg
// module id = 1093
// module chunks = 37